<template>
    <main id="mainCtrl">
        <WithdrawalDialog ref="withdrawalDialog" @updated="updateTable"/>
        <v-table id="table"
                 request-uri="withdrawals/getList"
                 pagesize="50"
                 :lazycount="true"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th name="created_at" sort="created_at" width="120">
                        Дата
                    </v-th>
                    <v-th name="doctor_name" minwidth="200">
                        Врач
                    </v-th>
                    <v-th name="doctor_url" minwidth="200">
                        URL
                    </v-th>
                    <v-th name="amount" sort="amount" width="100">
                        Сумма
                    </v-th>
                    <v-th name="tax_type" width="100">
                        Налог. режим
                    </v-th>
                    <v-th name="receipt_status" width="150">
                        Чек
                    </v-th>
                    <v-th name="status" sort="status" width="150">
                        Статус
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="created_at" v-slot="{filter}">
                        <date-piker v-model="filter.value"/>
                    </v-th>
                    <v-th name="doctor_name" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="doctor_url" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="amount" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="tax_type" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                ...v_s_convert(taxTypes)
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="receipt_status" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                ...v_s_convert(receiptStatuses)
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="status" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                ...v_s_convert(statuses)
                            ]'
                        ></v-select>
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index }">
                <v-tr class="hover pointer"
                      :id="'w-tr-' + item.id"
                      @click="(row, event) => handleRowClick(event, item, row)"
                >
                    <v-td name="created_at" highlight="*">
                        {{ item.created_at | formatDateTime }}
                    </v-td>
                    <v-td name="doctor_name">
                        {{ item.doctor.name }}
                    </v-td>
                    <v-td name="doctor_url">
                        <a :href="item.doctor.url" @click.prevent.stop="openHref(item.doctor.url)">
                            {{ item.doctor.url }}
                        </a>
                    </v-td>
                    <v-td name="amount" highlight="*">
                        {{ item.amount }} р.
                    </v-td>
                    <v-td name="tax_type">
                        {{ taxTypes[item.paymentData.tax_type] }}
                    </v-td>
                    <v-td name="receipt_status">
                        {{ receiptStatuses[item.receipt_status] }}
                    </v-td>
                    <v-td name="status" highlight="*">
                        {{ statuses[item.status] }}
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
import WithdrawalDialog from "@dialogs/admin/consult/Withdrawal";

export default {
    components: {
        WithdrawalDialog
    },
    data: function () {
        return {
            statuses: {
                '': '',
                'IN_PROCESS': 'Новая',
                'MONEY_SENT': '$ отправлены',
                'BLOCKED': 'Блокировка',
                'DONE': 'Выполнена',
                'REJECTED': 'Отклонена',
            },
            receiptStatuses: {
                '': '',
                'NOT_NEEDED': 'Не требуется',
                'NEEDED': 'Требуется',
                'UPLOADED': 'Загружен',
                'REJECTED': 'Отклонен',
                'ACCEPTED': 'Подтвержден',
            },
            taxTypes: {
                '': '',
                'SELF_EMPLOYED': 'Самозанятый',
                'I_P': 'ИП',
            },
        };
    },
    methods: {
        updateTable() {
            this.$refs.table.update();
            this.$bus.fire('updateMenu');
        },
        handleRowClick(event, item, row) {
            row.startLoadingAnimation();

            this.$refs.withdrawalDialog.show(item.id)
                .then(() => row.stopLoadingAnimation())
                .catch(() => row.stopLoadingAnimation());
        },
        openHref(href) {
            window.open(href)
        },
    },
}
</script>
